 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		69: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		69: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"9":"EmptySearchResultContainer","10":"EventsSearchPage","11":"GroupSearchFeedbackContainer","12":"MarcPage","13":"WidgetsPage","14":"app-components-bibs-subpages-MarcPage-MarcPageContainer","15":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintList","16":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList","17":"app-components-borrowing-sidebar-AccountSwitcher","18":"app-components-borrowing-sidebar-SingleClickHoldsPanel","19":"app-components-events-EventsSearchPage-EventsSearchPageContainer","20":"app-components-widgets-WidgetsPage-WidgetsPageContainer","21":"app-containers-AccountMessagesContainer","22":"app-containers-AllCommentsPageContainer","23":"app-containers-AllListsPageContainer","24":"app-containers-AllQuotationsPageContainer","25":"app-containers-AllRecommendationsPageContainer","26":"app-containers-AllReviewsPageContainer","27":"app-containers-AllSummariesPageContainer","28":"app-containers-AvailabilityDetailsContainer","29":"app-containers-BibPageContainer","30":"app-containers-CheckedOutContainer","31":"app-containers-CommentPageContainer","32":"app-containers-FinesContainer","33":"app-containers-HoldsContainer","34":"app-containers-InterlibraryLoansContainer","35":"app-containers-QuotationPageContainer","36":"app-containers-RecentlyReturnedContainer","37":"app-containers-SearchContainer","38":"app-containers-ShelfContainer","39":"app-containers-SummaryPageContainer","40":"app-containers-WorkflowContainer","41":"app-containers-print-PrintCheckedOutContainer","42":"app-containers-print-PrintHoldsContainer","43":"app-containers-print-PrintInterlibraryLoansContainer","44":"app-containers-print-PrintRecentlyReturnedContainer","45":"app-containers-print-PrintSearchContainer","46":"app-containers-print-PrintShelfContainer","47":"components-bibs-BibPage","48":"components-bibs-subpages-AllCommentsPage","49":"components-bibs-subpages-AllListsPage","50":"components-bibs-subpages-AllQuotationsPage","51":"components-bibs-subpages-AllRecommendationsPage","52":"components-bibs-subpages-AllReviewsPage","53":"components-bibs-subpages-AllSummariesPage","54":"components-bibs-subpages-CommentPage","55":"components-bibs-subpages-QuotationPage","56":"components-bibs-subpages-SummaryPage","57":"components-borrowing-accountmessages-AccountMessages","58":"components-borrowing-checkouts-CheckedOut","59":"components-borrowing-checkouts-CheckedOutPrintList","60":"components-borrowing-fines-Fines","61":"components-borrowing-holds-Holds","62":"components-borrowing-interlibraryLoans-InterlibraryLoans","63":"components-borrowing-recentlyreturned-RecentlyReturned","64":"components-search-EmptySearchResult","65":"components-search-Search","66":"components-shared-AvailabilityDetailOverlay","67":"components-shelves-Shelf","68":"containers-AccountSwitcherContainer","71":"sidebar-BorrowingSidebarToggleButton","72":"sidebar-MyBorrowingSidebar"}[chunkId]||chunkId) + "-" + {"0":"38d787ef2455d1705c63","1":"f5435a27b3190c171092","2":"b12036c411590d930cb1","3":"e94a8b85c6447c16645e","4":"f381ed77f413963b988d","5":"5d88c7a750740156d759","6":"ff543270bd99d0ef07b9","7":"0a7f27d0d82b33d31dfa","8":"e4069cf949105d66e057","9":"025e609f59d536c64ece","10":"cbb66688e011e7d2765c","11":"bb0af417e13f7da14619","12":"1442eb1d568b26da5e23","13":"3ef150dd9c44ec4e7dd8","14":"28603e9b1fe7f23f7003","15":"50c2c74afa093fc61db7","16":"b1def255251b62252ba9","17":"2504eacb28e79f9d6dcb","18":"614e2aafc47beb0202e0","19":"91eed901efc6fa3592f1","20":"53a06b1eafb0c473b29f","21":"66496a71c1e44665d98e","22":"f2c99abbe8007435856e","23":"151cbd2f1f50a9de8f22","24":"9518ef321040ccdcd335","25":"961916e72632e68f03d0","26":"ca294f2b4419fcc2384a","27":"d4425932a811452693c4","28":"8edbbb0339e6e45cf510","29":"3fe7f0384f0135b2a583","30":"4903fa9d54f9a5f53c0b","31":"f27813876998fcca82e7","32":"2a19d056cca3c9fbd859","33":"7110cb0151cbdf77eb4a","34":"085a028e3d4482a86487","35":"36eafce7a500f844b44d","36":"19180e29e2b2072c83c8","37":"faac6c67a9ca3b8a2290","38":"b36e42bbd75c0c3c0e58","39":"9cc3172a80d9651460fd","40":"5cfb3c8d4701fbc8a9a2","41":"86104a830b1496c8d3d9","42":"0b6b8628f6fdfb283a6a","43":"8382332b72d90581f856","44":"b1687de5bb3b963a81f0","45":"e08189303aa199c274a5","46":"7cb24cc3f0620133398b","47":"85bb26d7215ea32d5020","48":"ffe91e780b8c101400fd","49":"c17bf650739bbd071843","50":"1bb4c28920130d6e1822","51":"3b98430028501e422f62","52":"69da3b78eee2afd94e94","53":"dc358465c96ccf6f6e32","54":"3cce2438a5f7ba9b20f6","55":"490acc3b9683825c1276","56":"d6dbaeefacf0c285885a","57":"a70c6d0097c106f3ffd2","58":"ae1aefa90324e816c91d","59":"54e583dd93ff45608664","60":"0d20c684f9e80f39d1ff","61":"31e150484a2548432d0a","62":"594795f0b1bbf9b1c0c0","63":"e6b844b48c3cf01de2f0","64":"5cbdad1f1017532ff7b5","65":"4f29e8b004a0008de0af","66":"f5d10b52cbcdb16b2540","67":"a38bb40707b6d5975d6b","68":"22f98705c564f340862e","71":"799df33c007052916345","72":"efa9a5f242dad621a63b","73":"b913685c21fe8fddca1d","74":"61fb347eca184d42145a","75":"2a7de3111cc1acb4a61c","76":"0691471620b9007ff7de","77":"be7ec464c710e3d3122c","78":"947b99fae693ef498ed2","79":"0147ab4300ec63f53c99"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"10":1,"11":1,"12":1,"13":1,"15":1,"16":1,"17":1,"18":1,"29":1,"40":1,"42":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"9":"EmptySearchResultContainer","10":"EventsSearchPage","11":"GroupSearchFeedbackContainer","12":"MarcPage","13":"WidgetsPage","14":"app-components-bibs-subpages-MarcPage-MarcPageContainer","15":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintList","16":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList","17":"app-components-borrowing-sidebar-AccountSwitcher","18":"app-components-borrowing-sidebar-SingleClickHoldsPanel","19":"app-components-events-EventsSearchPage-EventsSearchPageContainer","20":"app-components-widgets-WidgetsPage-WidgetsPageContainer","21":"app-containers-AccountMessagesContainer","22":"app-containers-AllCommentsPageContainer","23":"app-containers-AllListsPageContainer","24":"app-containers-AllQuotationsPageContainer","25":"app-containers-AllRecommendationsPageContainer","26":"app-containers-AllReviewsPageContainer","27":"app-containers-AllSummariesPageContainer","28":"app-containers-AvailabilityDetailsContainer","29":"app-containers-BibPageContainer","30":"app-containers-CheckedOutContainer","31":"app-containers-CommentPageContainer","32":"app-containers-FinesContainer","33":"app-containers-HoldsContainer","34":"app-containers-InterlibraryLoansContainer","35":"app-containers-QuotationPageContainer","36":"app-containers-RecentlyReturnedContainer","37":"app-containers-SearchContainer","38":"app-containers-ShelfContainer","39":"app-containers-SummaryPageContainer","40":"app-containers-WorkflowContainer","41":"app-containers-print-PrintCheckedOutContainer","42":"app-containers-print-PrintHoldsContainer","43":"app-containers-print-PrintInterlibraryLoansContainer","44":"app-containers-print-PrintRecentlyReturnedContainer","45":"app-containers-print-PrintSearchContainer","46":"app-containers-print-PrintShelfContainer","47":"components-bibs-BibPage","48":"components-bibs-subpages-AllCommentsPage","49":"components-bibs-subpages-AllListsPage","50":"components-bibs-subpages-AllQuotationsPage","51":"components-bibs-subpages-AllRecommendationsPage","52":"components-bibs-subpages-AllReviewsPage","53":"components-bibs-subpages-AllSummariesPage","54":"components-bibs-subpages-CommentPage","55":"components-bibs-subpages-QuotationPage","56":"components-bibs-subpages-SummaryPage","57":"components-borrowing-accountmessages-AccountMessages","58":"components-borrowing-checkouts-CheckedOut","59":"components-borrowing-checkouts-CheckedOutPrintList","60":"components-borrowing-fines-Fines","61":"components-borrowing-holds-Holds","62":"components-borrowing-interlibraryLoans-InterlibraryLoans","63":"components-borrowing-recentlyreturned-RecentlyReturned","64":"components-search-EmptySearchResult","65":"components-search-Search","66":"components-shared-AvailabilityDetailOverlay","67":"components-shelves-Shelf","68":"containers-AccountSwitcherContainer","71":"sidebar-BorrowingSidebarToggleButton","72":"sidebar-MyBorrowingSidebar"}[chunkId]||chunkId) + "-" + {"0":"38d787ef2455d1705c63","1":"f5435a27b3190c171092","2":"b12036c411590d930cb1","3":"e94a8b85c6447c16645e","4":"f381ed77f413963b988d","5":"5d88c7a750740156d759","6":"ff543270bd99d0ef07b9","7":"0a7f27d0d82b33d31dfa","8":"e4069cf949105d66e057","9":"025e609f59d536c64ece","10":"cbb66688e011e7d2765c","11":"bb0af417e13f7da14619","12":"1442eb1d568b26da5e23","13":"3ef150dd9c44ec4e7dd8","14":"28603e9b1fe7f23f7003","15":"50c2c74afa093fc61db7","16":"b1def255251b62252ba9","17":"2504eacb28e79f9d6dcb","18":"614e2aafc47beb0202e0","19":"91eed901efc6fa3592f1","20":"53a06b1eafb0c473b29f","21":"66496a71c1e44665d98e","22":"f2c99abbe8007435856e","23":"151cbd2f1f50a9de8f22","24":"9518ef321040ccdcd335","25":"961916e72632e68f03d0","26":"ca294f2b4419fcc2384a","27":"d4425932a811452693c4","28":"8edbbb0339e6e45cf510","29":"3fe7f0384f0135b2a583","30":"4903fa9d54f9a5f53c0b","31":"f27813876998fcca82e7","32":"2a19d056cca3c9fbd859","33":"7110cb0151cbdf77eb4a","34":"085a028e3d4482a86487","35":"36eafce7a500f844b44d","36":"19180e29e2b2072c83c8","37":"faac6c67a9ca3b8a2290","38":"b36e42bbd75c0c3c0e58","39":"9cc3172a80d9651460fd","40":"5cfb3c8d4701fbc8a9a2","41":"86104a830b1496c8d3d9","42":"0b6b8628f6fdfb283a6a","43":"8382332b72d90581f856","44":"b1687de5bb3b963a81f0","45":"e08189303aa199c274a5","46":"7cb24cc3f0620133398b","47":"85bb26d7215ea32d5020","48":"ffe91e780b8c101400fd","49":"c17bf650739bbd071843","50":"1bb4c28920130d6e1822","51":"3b98430028501e422f62","52":"69da3b78eee2afd94e94","53":"dc358465c96ccf6f6e32","54":"3cce2438a5f7ba9b20f6","55":"490acc3b9683825c1276","56":"d6dbaeefacf0c285885a","57":"a70c6d0097c106f3ffd2","58":"ae1aefa90324e816c91d","59":"54e583dd93ff45608664","60":"0d20c684f9e80f39d1ff","61":"31e150484a2548432d0a","62":"594795f0b1bbf9b1c0c0","63":"e6b844b48c3cf01de2f0","64":"5cbdad1f1017532ff7b5","65":"4f29e8b004a0008de0af","66":"f5d10b52cbcdb16b2540","67":"a38bb40707b6d5975d6b","68":"22f98705c564f340862e","71":"799df33c007052916345","72":"efa9a5f242dad621a63b","73":"b913685c21fe8fddca1d","74":"61fb347eca184d42145a","75":"2a7de3111cc1acb4a61c","76":"0691471620b9007ff7de","77":"be7ec464c710e3d3122c","78":"947b99fae693ef498ed2","79":"0147ab4300ec63f53c99"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 681);
